export default {}; export const SplashPage = undefined;